import React from 'react';
import MaterialIcon from "./MaterialIcon.jsx";

export default function Chevron({ expanded, ...props }) {
	return (<MaterialIcon
			{...props}
		>
			{expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
		</MaterialIcon>
	);
}